import { roomIdSchema } from '@bia/protocol'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Guard } from '@/components/state/Guard'
import { Sala } from '@/features/sessao/Sala'

/**
 * A sala durante a série.
 *
 * Fica fora da camada `_portal` de propósito: esta é a única tela do
 * paciente na superfície `sala`, e a própria página carrega o
 * `data-surface`. Nada pode ser embrulhado em torno dela.
 *
 * `?s=` é o caminho normal, com sessão marcada: o papel sai da linha da
 * sessão e o check-in tem a que se prender. `?room=` é a entrada anônima,
 * que só existe fora de produção e serve para medir a deriva entre duas
 * máquinas, com `/measure/sala` na outra ponta.
 */
const salaSearch = z.object({
  s: z.uuid().optional().catch(undefined),
  room: roomIdSchema.optional().catch(undefined),
  measure: z
    .union([z.boolean(), z.string(), z.number()])
    .optional()
    .transform((value) => value === true || value === 1 || value === '1' || value === 'true')
    .catch(false),
  label: z.string().max(80).optional().catch(undefined),
})

export const Route = createFileRoute('/portal/sala')({
  validateSearch: salaSearch,
  component: function SalaDoPaciente() {
    const { s, room, measure, label } = Route.useSearch()
    // Sessão marcada pede a conta dela: o link copiado no console cai no
    // login por código e volta para cá. A sala anônima da medição não pede.
    if (s !== undefined) {
      return (
        // biome-ignore lint/a11y/useValidAriaRole: papel da aplicação, não papel ARIA
        <Guard role="patient">
          <Sala key={s} sessionId={s} measure={measure} label={label ?? ''} />
        </Guard>
      )
    }
    return (
      <Sala
        key={room ?? 'sala-teste'}
        roomId={room ?? 'sala-teste'}
        measure={measure}
        label={label ?? ''}
      />
    )
  },
})
